import React from 'react';

const DropDownIcon = (): JSX.Element => (
  <svg
    width="13"
    height="8"
    viewBox="0 0 13 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.01829 1L6.41463 7L11.811 1"
      stroke="#0193E5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DropDownIcon;
